import React from 'react'
import { Paragraph } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

import { Contract } from '../../../../../common/validations'
import { resolveContractTerminationTerminology } from '../../utils/resolveContractTerminationTerminology'

import { FormValues } from 'views/TerminateContract/TerminateForm/initialValues'

interface TerminateInstructionsProps {
  contract: Contract
  formValues: FormValues
}

export const TerminateInstructions: React.FC<TerminateInstructionsProps> = ({
  contract,
  formValues,
}) => {
  const { t } = useTranslation(['common', 'terminateContract'])
  const terminology = resolveContractTerminationTerminology(
    contract.contractType
  )

  return (
    <Paragraph large className="whitespace-pre-line">
      {t(terminology.instructions, {
        endDate: formValues.firstPossibleEndDate.toFormat('dd.MM.yyyy'),
      })}
    </Paragraph>
  )
}
